// Auto-generated by scripts/gen-vuetify-components.js
// Run: node scripts/gen-vuetify-components.js frontend/qr_code_visit.js frontend/vuetify-components-qr_code_visit.js
/* eslint-disable */

import 'vuetify/src/styles/main.sass'
import 'vuetify/src/components/VApp/VApp.sass'
import 'vuetify/src/components/VCounter/VCounter.sass'
import 'vuetify/src/components/VIcon/VIcon.sass'
import 'vuetify/src/components/VInput/VInput.sass'
import 'vuetify/src/components/VLabel/VLabel.sass'
import 'vuetify/src/components/VMessages/VMessages.sass'
import 'vuetify/src/components/VProgressLinear/VProgressLinear.sass'
import 'vuetify/src/components/VTextField/VTextField.sass'

import {
  VApp,
  VCounter,
  VIcon,
  VInput,
  VLabel,
  VMessages,
  VProgressLinear,
  VTextField,
} from 'vuetify/lib'

const components = {
  VApp,
  VCounter,
  VIcon,
  VInput,
  VLabel,
  VMessages,
  VProgressLinear,
  VTextField,
}

export default components
